@use "ui/styles/colorsOld";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/colors";
@use "ui/styles/breakpoints";

.wrapper {
  display: flex;
  align-items: stretch;
  gap: sizes.$s6;

  @include breakpoints.mobile {
    flex-wrap: wrap;
    gap: sizes.$s4 sizes.$s6;
  }

  :global {
    a,
    span {
      padding: sizes.$s6 0;
      transition: color 0.3s;

      @include fontStyles.h5-book;
      @include fontStyles.subdued;

      &.selected {
        color: colors.$blue;
        box-shadow: inset 0px -4px 0px 0px colors.$blue;
      }

      &:hover {
        cursor: pointer;
        color: colors.$blue;
      }

      @include breakpoints.mobile {
        padding: sizes.$s3 0 sizes.$s4;
      }
    }
  }
}
